module.exports = __webpack_public_path__ + "static/media/referring-pages-sample.2cab060b.png";